import { getStore } from '../store/Store';
import { mutatorAction } from 'satcheljs';
import { setItem } from 'owa-local-storage';

export const onSenderColumnWidthChangedInternalMutator: (senderColumnWidth: number) => void =
    mutatorAction(
        'onSenderColumnWidthChangedInternalMutator',
        (senderColumnWidth: number): void => {
            getStore().senderColumnWidth = senderColumnWidth;
            updateLocalColumnWidths(
                senderColumnWidth,
                getStore().subjectColumnWidth,
                getStore().receivedColumnWidth,
                getStore().sortedContentColumnWidth
            );
        }
    );

export const onSubjectColumnWidthChangedInternalMutator: (subjectColumnWidth: number) => void =
    mutatorAction(
        'onSubjectColumnWidthChangedInternalMutator',
        (subjectColumnWidth: number): void => {
            getStore().subjectColumnWidth = subjectColumnWidth;
            updateLocalColumnWidths(
                getStore().senderColumnWidth,
                subjectColumnWidth,
                getStore().receivedColumnWidth,
                getStore().sortedContentColumnWidth
            );
        }
    );

export const onReceivedColumnWidthChangedInternalMutator: (receivedColumnWidth: number) => void =
    mutatorAction(
        'onReceivedColumnWidthChangedInternalMutator',
        (receivedColumnWidth: number): void => {
            getStore().receivedColumnWidth = receivedColumnWidth;
            updateLocalColumnWidths(
                getStore().senderColumnWidth,
                getStore().subjectColumnWidth,
                receivedColumnWidth,
                getStore().sortedContentColumnWidth
            );
        }
    );

export const onSortedContentColumnWidthChangedInternalMutator: (
    sortedContentColumnWidth: number
) => void = mutatorAction(
    'onSortedContentColumnWidthChangedInternalMutator',
    (sortedContentColumnWidth: number): void => {
        getStore().sortedContentColumnWidth = sortedContentColumnWidth;
        updateLocalColumnWidths(
            getStore().senderColumnWidth,
            getStore().subjectColumnWidth,
            getStore().receivedColumnWidth,
            sortedContentColumnWidth
        );
    }
);

// This function stores the adjusted column widths (i.e. the user's preferred column
// widths + any adjustments made to fit the columns within the available space) in
// local storage so that we can render the columns at the appropriate width the
// next time the user reloads the page.
const updateLocalColumnWidths = (
    senderColumnWidth: number | null,
    subjectColumnWidth: number | null,
    receivedColumnWidth: number | null,
    sortedContentColumnWidth: number | null
) => {
    if (senderColumnWidth === null || subjectColumnWidth === null || receivedColumnWidth === null) {
        return;
    }
    setItem(
        window,
        `MailListColumnWidths`,
        JSON.stringify({
            senderColumnWidth,
            subjectColumnWidth,
            receivedColumnWidth,
            sortedContentColumnWidth,
        })
    );
};
